// Migrated to ES6 class syntax for ol@10 compat (removed inherits() from ol/index.js).
import XYZSource from 'ol/source/XYZ.js';

/*eslint no-self-assign: "off"*/
/*eslint default-case: "off"*/

/**
 * Source que serve tiles em grid pelo padrão LRC (level/row/column).
 * Estende ol/source/XYZ pra reaproveitar tile loading e cache.
 *
 * @extends {XYZSource}
 */
class LrcSource extends XYZSource {
  /**
   * @param {object} options Image tile options
   */
  constructor(options) {
    super({
      attributions: options.attributions,
      cacheSize: options.cacheSize,
      extent: options.extent,
      opaque: options.opaque,
      projection: options.projection !== undefined ? options.projection : 'EPSG:3857',
      state: options.state,
      tileGrid: options.tileGrid,
      tilePixelRatio: options.tilePixelRatio,
      wrapX: options.wrapX === undefined ? true : options.wrapX,
      transition: options.transition,
      minZoom: options.minZoom,
      maxZoom: options.maxZoom,
      // tileUrlFunction precisa ser definido depois do super() pra ter acesso a `this`
    });
    this.setTileUrlFunction(this.defaultCreateTileFunction(options.url));
  }

  /**
   * @param {number} n Level number.
   * @private
   */
  _addLeadingZeroLevel(n) {
    var out = String(n);

    if (out.length === 1)
      out = "0" + out;

    return out;
  }

  /**
   * @param {number} n Number to be formated.
   * @private
   */
  _addLeadingZero(n) {
    var out = n.toString(16);

    switch (out.length) {
      case 1:
        out = "0000000" + out;
        break;
      case 2:
        out = "000000" + out;
        break;
      case 3:
        out = "00000" + out;
        break;
      case 4:
        out = "0000" + out;
        break;
      case 5:
        out = "000" + out;
        break;
      case 6:
        out = "00" + out;
        break;
      case 7:
        out = "0" + out;
        break;
    }

    return out;
  }

  /**
   * @param {number[]} tileCoord [z, x, y] number array
   * @return {number[]} [z, x, y] number array
   * @private
   */
  _generateUrlTileCoord(tileCoord) {
    var wrappedCoord = this.getTileCoordForTileUrlFunction(tileCoord);

    return [wrappedCoord[0], wrappedCoord[1], -wrappedCoord[2] - 1];
  }

  /**
   * @param {string} templateUrl Template url.
   * @return {function} Tile URL function.
   * @protected
   */
  defaultCreateTileFunction(templateUrl) {
    var tileUrlFunction = (tileCoord) => {
      if (!tileCoord) { return ""; }

      var wrappedCoord = this._generateUrlTileCoord(tileCoord);

      return templateUrl.replace('{l}', this._addLeadingZeroLevel(wrappedCoord[0]))
        .replace('{r}', this._addLeadingZero(wrappedCoord[2]))
        .replace('{c}', this._addLeadingZero(wrappedCoord[1]));
    };

    return tileUrlFunction;
  }
}

export default LrcSource;
